import Service from './abstract';
import axios from 'axios';
// import { dataUriToBase64, dataURLtoFile, getRequestHash } from "../utils/helpers";
import { types } from '../constants/files';

const BUCKET = process.env.REACT_APP_PUBLIC_S3_BUCKET || "";
// const BUCKET = 'staticfintech01-testing';

export class CuotitasStores extends Service {
    constructor() {
        super('cuotitasstores')
    }

    // point to local signs microservice
    // get baseURL() {
    //     return `http://localhost:64055`
    // }

    async uploadS3(data) {
        const fileBlob = dataURIToBlob(data.fileUri);
    
        const params = new URLSearchParams({
          idType: types.document.toString(),
          bucket: BUCKET,
          dirname: data.dirname,
          filename: data.filename,
        });
    
        const { url, fields } = await this.get(
           `/files/presigned?${params.toString()}`
        );
    
        const formData = new FormData();
    
        Object.keys(fields).forEach((key) => {
          formData.append(key, fields[key]);
        });
    
        formData.append("file", fileBlob);
    
        await axios.post(url, formData);
    
        return `${url}/${data.dirname}/${data.filename}`;
      }
     
    
}

export const dataURIToBlob = (dataURI) => {
    const splitDataURI = dataURI.split(",");
    const byteString =
      splitDataURI[0].indexOf("base64") >= 0
        ? window.atob(splitDataURI[1])
        : decodeURI(splitDataURI[1]);
    const mimeString = splitDataURI[0].split(":")[1].split(";")[0];
  
    const ia = new Uint8Array(byteString.length);
  
    for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);
  
    return new Blob([ia], { type: mimeString });
  };
// eslint-disable-next-line import/no-anonymous-default-export
export default new CuotitasStores()
